import { render, staticRenderFns } from "./land-prems.vue?vue&type=template&id=381aab2a&"
import script from "./land-prems.vue?vue&type=script&lang=js&"
export * from "./land-prems.vue?vue&type=script&lang=js&"
import style0 from "./land-prems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports